import BookingOptionsComponent from "../../../../components/partner/bookings-list/booking-options";

export default function BookingOptions() {
    return <BookingOptionsComponent />;
  }